/**
 * Everything specific to this wedding. Fork the project, edit this file,
 * swap the photos in /public/img, and the whole site follows.
 */
export const WEDDING = {
	couple: {
		short: 'K & A',
		names: ['Kojo', 'Afua'] as const,
		/** Used on visa invitation letters. */
		fullNames: ['Kojo Boakye', 'Afua Boakye'] as const,
	},
	/** Return address printed on visa invitation letters. */
	hostAddress: ['East Legon', 'Accra, Ghana'] as const,
	siteUrl: 'https://example.com',
	title: 'Kojo & Afua',
	hashtag: '#KojoAndAfua',
	location: 'Accra & Senchi, Ghana',
	dateLabel: 'March 2024',
	scripture: {
		text: 'And now these three remain: faith, hope and love. But the greatest of these is love.',
		cite: '1 Corinthians 13:13',
	},
	/** Currency for registry pledges (display only — no payments are taken). */
	currency: 'GBP',
	contactEmail: 'hello@example.com',
	/** Sender for transactional email (override with EMAIL_FROM). */
	emailFrom: 'noreply@example.com',
	ceremonies: [
		{
			id: 'traditional',
			event: null,
			title: 'Traditional ceremony',
			date: '2024-03-21T10:00:00Z',
			venue: 'The Boakye family home, East Legon',
			city: 'Accra',
			dress: 'Traditional colours — kente and African print',
			image: '/img/demo/wedding/traditional.webp',
			moments: [
				'The knocking ceremony',
				'The presentation of gifts',
				'The unveiling of the bride',
			],
		},
		{
			id: 'white',
			event: 'WHITE_WEDDING',
			title: 'The white wedding',
			date: '2024-03-23T13:00:00Z',
			venue: 'The Royal Senchi Hotel and Resort',
			city: 'Akosombo',
			dress: 'Formal — colour code to follow',
			image: '/img/demo/wedding/white-wedding.webp',
			moments: ['Processional', 'Exchange of vows', 'Signing of the register'],
		},
		{
			id: 'reception',
			event: 'RECEPTION',
			title: 'Reception',
			date: '2024-03-23T14:00:00Z',
			venue: 'The Royal Senchi Hotel and Resort',
			city: 'Akosombo',
			dress: 'Formal — dance shoes encouraged',
			image: '/img/demo/wedding/reception.webp',
			moments: ['Grand entrance', 'First dance', 'Dinner & toasts', 'Festivities'],
		},
	],
} as const

export const COUNTRIES = [
	'Ghana',
	'United Kingdom',
	'United States',
	'Germany',
	'Canada',
	'Netherlands',
	'Nigeria',
	'India',
	'Singapore',
	'South Africa',
	'France',
	'Portugal',
	'Other',
] as const

export const DIETARY_NEEDS = [
	'Vegan',
	'Lactose intolerance',
	'Vegetarian',
	'Gluten intolerance',
	'Halal',
	'Dairy-free',
	'Kosher',
	'Other',
] as const

export const ALLERGIES = [
	'Eggs',
	'Fish & shellfish',
	'Soy',
	'Nuts & seeds',
	'Peanuts',
	'Lactose',
	'Other',
] as const
